import React, { useEffect, useRef } from "react";
import { BASE_URL, DOMAIN } from "./../../global";
import { Link } from "react-router-dom";
import moment from "moment";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";
import { ToastContainer, toast } from "react-toastify";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import LastPageIcon from "@mui/icons-material/LastPage";
import IconButton from "@mui/material/IconButton";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { useTheme } from "@mui/material/styles";

import {
  Button,
  TableContainer,
  Toolbar,
  TextField,
  Autocomplete,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Modal,
  Box,
  Typography,
  TablePagination,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  ButtonGroup,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import ExcelDownload from "../../utils/components/excelDownload";
import html2pdf from "html2pdf.js";
import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";
import { Table } from "react-bootstrap";
import { showComponent } from "../helper/helpers";

var form11Columns = [
  {
    id: "id",
    label: "Sr. No.",
    align: "left",
    minWidth: 40,
  },
// {
//   id: "reportNumber",
//   label: "Report Number",
//   align: "left",
//   minWidth: 40,
// },
  // {
  //   id: "equipment_name",
  //   label: "Name of Equipment",
  //   align: "left",
  //   minWidth: 40,
  // },
  {
    id: "factoryName",
    label: "Name of Factory Occupier",
    align: "left",
    minWidth: 40,
  },
  {
    id: "addressFactory",
    label: "Address of Factory",
    align: "left",
    minWidth: 40,
  },
{
  id: "reportNumber",
  label: "Report Number",
  align: "left",
  minWidth: 40,
},
  {
    id: "inspectionDate",
    label: "Date of Testing",
    align: "left",
    minWidth: 40,
  },
  {
    id: "certificateValidity",
    label: "Next due Date of Testing",
    align: "left",
    minWidth: 40,
  },
];

var form13Columns = [
  {
    id: "id",
    label: "Sr. No.",
    align: "left",
    minWidth: 40,
  },
  {
    id: "reportNumber",
    label: "Report Number",
    align: "left",
    minWidth: 40,
  },
  // {
  //   id: "equipment_name",
  //   label: "Name of Equipment",
  //   align: "left",
  //   minWidth: 40,
  // },
  {
    id: "distinctiveNumber",
    label: "Name of Equipment / Plant",
    align: "left",
    minWidth: 40,
  },
  {
    id: "recommendedAfterExamination",
    label: "Safe Working Load",
    align: "left",
    minWidth: 40,
  },
  {
    id: "utrasonicTestDate",
    label: "Ultrasonic Examination Date of Testing",
    align: "left",
    minWidth: 40,
  },
  {
    id: "utrasonicNextDueDate",
    label: "Ultrasonic Next Due Date of Testing",
    align: "left",
    minWidth: 40,
  },
  {
    id: "internalTestDate",
    label: "Internal Examination Date of Testing",
    align: "left",
    minWidth: 40,
  },
  {
    id: "internalExaminationDueDate",
    label: "Internal Next Due Date of Testing",
    align: "left",
    minWidth: 40,
  },
  {
    id: "hydraulicTestDate",
    label: "Hydraulic Examination Date of Testing",
    align: "left",
    minWidth: 40,
  },
  {
    id: "hydraulicNextDueDate",
    label: "Hydraulic Next Due Date of Testing",
    align: "left",
    minWidth: 40,
  },
  {
    id: "certificateValidity",
    label: "Certificate Validity",
    align: "left",
    minWidth: 40,
  },
];

const notNeededColumn = ["id"];

const RenewalReport = (props) => {
  const printComponentRef = React.useRef();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [searchBy, setSearchBy] = React.useState("");
  const [searchKey, setSearchKey] = React.useState("");
  const [totalRows, setTotalRows] = React.useState(0);
  const _clientId = localStorage.getItem("clientId");
  const _userType = localStorage.getItem("type");
  const [from, setFrom] = React.useState(null);
  const [to, setTo] = React.useState(null);
  const [finalData, setFinalData] = React.useState([]);
  const [downloadPdfloading, setDownlaodPdfLoading] = React.useState(false);
  const [templateList, setTemplateList] = React.useState([]);
  const [factoryList, setFactoryList] = React.useState([]);
  const [shopsList, setShopsList] = React.useState([]);
  const [selectedIds, setSelectedIds] = React.useState({
    templateId: null,
    factoryId: null,
    shopId: null,
  });
  // let columns = selectedIds?.templateId == 12 ? form13Columns : form11Columns;
  let columns = form11Columns

  const getQuery = (count) => {
    let whereConditions = "";
    let pagination_settings = "";
    let hasWhere = false;
  
    if (selectedIds?.templateId) {
      whereConditions += ` WHERE reportValues.templateId = ${selectedIds?.templateId}`;
      hasWhere = true;
    }
  
    if (selectedIds?.factoryId) {
      let colName =
        "REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.factoryId'), '\"', '')";
      whereConditions += hasWhere
        ? ` AND ${colName} = ${selectedIds?.factoryId}`
        : ` WHERE ${colName} = ${selectedIds?.factoryId}`;
      hasWhere = true;
    }
  
    if (selectedIds?.shopId) {
      let colName =
        "REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.shopId'), '\"', '')";
      whereConditions += hasWhere
        ? ` AND ${colName} = ${selectedIds?.shopId}`
        : ` WHERE ${colName} = ${selectedIds?.shopId}`;
      hasWhere = true;
    }
  
    if (to != null && from != null) {
      let colName =
        "DATE(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.certificateValidity'), '\"', ''))";
      whereConditions += hasWhere
        ? ` AND ${colName} BETWEEN DATE('${moment(from).format("YYYY-MM-DD")}') AND DATE('${moment(to).format("YYYY-MM-DD")}')`
        : ` WHERE ${colName} BETWEEN DATE('${moment(from).format("YYYY-MM-DD")}') AND DATE('${moment(to).format("YYYY-MM-DD")}')`;
      hasWhere = true;
    }else {
      // Default to last 10 days
      const tenDaysLater = moment().add(10, "days").format("YYYY-MM-DD");
      const today = moment().format("YYYY-MM-DD");
      let colName =
        "DATE(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.certificateValidity'), '\"', ''))";
      whereConditions += hasWhere
        ? ` AND ${colName} < DATE('${tenDaysLater}')`
        : ` WHERE ${colName} < DATE('${tenDaysLater}')`;
      hasWhere = true;
    }
    
    if (_userType == 3)
      whereConditions +=
        whereConditions.length > 0
          ? `and JSON_EXTRACT(reportValues.templateValues, '$.factoryId') = ${_clientId}`
          : `where JSON_EXTRACT(reportValues.templateValues, '$.factoryId') = ${_clientId}`;
  
    if (rowsPerPage != -1) {
      pagination_settings = `LIMIT ${rowsPerPage} OFFSET ${
        rowsPerPage * Number(page)
      }`;
    }
  
    let data = {
      query: `SELECT reportValues.templateId, reportValues.id, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.reportNumber'), '\"', ''), '') AS reportNumber, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.certificateValidity'), '\"', ''), '') AS certificateValidity, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.Occupier'), '\"', ''), '') AS factoryName, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.addressFactory'), '\"', ''), '') AS addressFactory, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.internalTestDate'), '\"', ''), '') AS internalTestDate, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.shopId'), '\"', ''), '') AS shopId, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.reportDate'), '\"', ''), '') AS reportDate, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.equipmentId'), '\"', ''), '') AS equipmentId, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.typeIdentificationNumber'), '\"', ''), '') AS typeIdentificationNumber,
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.distinctiveNumber'), '\"', ''), '') AS distinctiveNumber, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.capacity'), '\"', ''), '') AS capacity, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.dateOfExamination'), '\"', ''), '') AS dateOfExamination, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.inspectionDate'), '\"', ''), '') AS inspectionDate, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.recommendedAfterExamination'), '\"', ''), '') AS recommendedAfterExamination, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.utrasonicTestDate'), '\"', ''), '') AS utrasonicTestDate, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.hydraulicTestDate'), '\"', ''), '') AS hydraulicTestDate, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.internalTestDate'), '\"', ''), '') AS internalTestDate, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.internalExaminationDueDate'), '\"', ''), '') AS internalExaminationDueDate, 
              IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.certificateValidityDate'), '\"', ''), '') AS certificateValidityDate, 
              templates.name, 
              clients.name AS client_name, 
              addresses.address AS client_address, 
              clients.emailId AS client_email, 
              shops.name AS shop_name, 
              products.name AS equipment_name 
              FROM reportValues 
              LEFT JOIN templates ON reportValues.templateId = templates.id 
              LEFT JOIN clients ON JSON_EXTRACT(reportValues.templateValues, '$.factoryId') = clients.id 
              LEFT JOIN addresses ON addresses.id = SUBSTRING_INDEX(clients.address, ',', 1) 
              LEFT JOIN shops ON REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.shopId'), '\"', '') = shops.id 
              LEFT JOIN products ON REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.equipmentId'), '\"', '') = products.id 
              ${whereConditions} 
              ORDER BY id ASC 
              ${pagination_settings}`,
    };
  
    if (count)
      data.query = `SELECT COUNT(*) AS no_of_rows FROM reportValues 
                    LEFT JOIN templates ON reportValues.templateId = templates.id 
                    ${whereConditions}`;
  
    return data;
  };

  // api calls
  function getTotalRows() {
    let data = getQuery(true);

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0]?.no_of_rows);
      })
      .catch((err) => {
        console.log("datasheet data fetching error: ", err);
      });
  }

  function fetchFinalData() {
    let data = getQuery();

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setFinalData(res.data);
      })
      .catch((err) => {
        console.log("  error: ", err);
      });
  }

  const search = () => {
    fetchFinalData();
  };



  const generatePDF = async () => {
    setDownlaodPdfLoading(true);
    try {
      const element = printComponentRef.current;
      let pdf = await html2pdf()
        .from(element)
        .set({
          margin: [10, 1, 20, 1],
          filename: `masterInOut.pdf`,
          pagebreak: { after: "section", mode: ["css", "legacy"] },
          html2canvas: {
            dpi: 192,
            scale: 4,
            letterRendering: true,
            useCORS: true,
          },
          jsPDF: {
            orientation: "portrait",
            unit: "pt",
            format: "a4",
          },
        })
        .toPdf()
        .get("pdf");

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(0, 0, 0);
        pdf.setFont("helvetica", "bold");

        // const text = "SUMMARY REPORT";
        // const pageWidth = pdf.internal.pageSize.getWidth();
        // const textWidth =
        //   (pdf.getStringUnitWidth(text) * 12) / pdf.internal.scaleFactor;
        // const x = (pageWidth - textWidth) / 2;
        // pdf.setFontSize(12);
        // pdf.text(text, x, 20);
      }

      const blob = pdf.output("blob");
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `summaryReport.pdf`;
      a.click();

      setDownlaodPdfLoading(false);
    } catch (error) {
      console.error("Error generating PDF:", error);
      setDownlaodPdfLoading(false);
    }
  };

  const getAllTemplate = () => {
    axiosWithToken
      .get(BASE_URL + `templates`)
      .then((res) => {
        setTemplateList(res.data);
      })
      .catch((err) => {
        console.log(" error: ", err);
      });
  };

  const getAllFactory = () => {
    axiosWithToken
      .get(BASE_URL + `clients`)
      .then((res) => {
        setFactoryList(res.data);
      })
      .catch((err) => {
        console.log(" error: ", err);
      });
  };

  const getAllShops = () => {
    axiosWithToken
      .get(BASE_URL + `shops`)
      .then((res) => {
        setShopsList(res.data);
      })
      .catch((err) => {
        console.log(" error: ", err);
      });
  };

  var refresh = () => {
    window.location.reload(false);
  };

  useEffect(() => {
    getTotalRows();
    getAllTemplate();
    getAllFactory();
    getAllShops();
    fetchFinalData();
  }, []);

  // useEffect(() => {
  //   fetchFinalData();
  // }, [rowsPerPage, page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  return (
    <div>
      <div
        className="mb-2"
        style={{
          display: "flex",
          float: "left",
          flexWrap:"wrap",
          justifyContent: "flex-end",
          gap:"10px", 
          width:"95%",
          margin:"auto 10px"
        }}
      >
        <div>
        <Autocomplete
          sx={{
            m: 0,
            minWidth: 150,
          }}
          size="small"
          onChange={(event, newValue) => {
            setSelectedIds((prevState) => ({
              ...prevState,
              templateId: newValue ? newValue.id : null,
            }));
          }}
          options={templateList}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField {...params} label="Select Form Type" />
          )}
        />
        </div>
        <div>
          <Autocomplete
            sx={{
              m: 0,
              minWidth: 150,
            }}
            size="small"
            onChange={(event, newValue) => {
              setSelectedIds((prevState) => ({
                ...prevState,
                factoryId: newValue ? newValue.id : null,
              }));
            }}
            options={_userType == 3 ? factoryList?.filter((item) => item.id == _clientId): factoryList}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField {...params} label="Select Factory" />
            )}
          />
        </div>

        <div
          style={{ width: "150px" }}
          id="quotationlist_datefrom"
        >
          <LocalizationProvider dateAdapter={AdapterDateFns} classNames="mr-2">
            <DatePicker
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              label="From"
              value={from ? new Date(from) : ""}
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              onChange={(newValue) => setFrom(newValue)}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
          </LocalizationProvider>
        </div>

        <div
          style={{ marginRight: "10px", width: "150px" }}
          id="quotationlist_dateto"
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              label="To"
              value={to ? new Date(to) : ""}
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              onChange={(newValue) => setTo(newValue)}
              renderInput={(params) => <TextField {...params} size="small" />}
              style={{ marginRight: "20px" }}
            />
          </LocalizationProvider>
        </div>

        <Button
          variant="contained"
          size="small"
          sx={{ height: "40px" }}
          onClick={() => {
            search();
          }}
        >
          <SearchIcon />
        </Button>

        <ExcelDownload
          finalData={finalData}
          notNeededColumn={notNeededColumn}
        />

        <Button
          variant="contained"
          size="small"
          sx={{ height: "40px" }}
          onClick={() => {
            generatePDF();
          }}
        >
          Download PDF
        </Button>
      </div>
      <br />
      <TableContainer component={Paper} sx={{ mt: 2, p: 2 }}>
        <div
          style={{ border: "1px solid black", padding: "5px",  }}
          ref={printComponentRef}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            size="small"
            id="invoicelist_table"
            sx ={{borderCollapse :"collapse",}}
          >
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth, fontSize:"12px" }}
                  >
                    {/* {index === 1  ? (
                <b>{`${columns[1].label}  /  Plant`}</b>
              ) : ( */}
                    <b>{column.label}</b>
                    {/* )} */}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {finalData?.map((row, index) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                  {columns.map((column, columnIndex) => {
                
                      let value;
                      if (
                        column.id === "certificateValidity" ||
                        column.id === "inspectionDate" ||
                        column.id === "hydraulicTestDate" ||
                        column.id === "internalTestDate" ||
                        column.id === "utrasonicTestDate"
                      ) {
                        let newDate = moment(row[column.id]).format(
                          "DD-MM-YYYY"
                        );
                        value = row[column.id] ? newDate : null;
                      } else {
                        value = row[column.id];
                      }
                      if (column.id === "id") {
                        value = page * rowsPerPage + index + 1;
                      }

                         // Define dynamic style for certificateValidity column
                        let dynamicStyle = { fontSize: "12px" };
                        if (column.id === "certificateValidity" && row[column.id]) {
                          const isFuture = moment(row[column.id]).isAfter(moment(), "day");
                          dynamicStyle.color = isFuture ? "green" : "red";
                        }

                      return (
                        <TableCell key={column.id} align={column.align} style={dynamicStyle}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100, { label: "All", value: -1 }]}
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          component="div"
          colSpan={3}
          SelectProps={{
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          }}
          ActionsComponent={TablePaginationActions}
        />
      </TableContainer>
      {downloadPdfloading && (
        <DownloadPdfLoaderModal
          loading={downloadPdfloading}
          name={"Summary Report"}
        />
      )}
    </div>
  );
};

export default RenewalReport;